import axios from 'axios';

axios.defaults.headers.put['Content-Type'] = 'application/x-www-form-urlencoded';

const _DEV = 0;
const _TESTE = 1;
const _PROD = 2;

const ambienteHCFamema = [
  'https://localhost:44365',
  'https://srvaplic2.famema.br/AvaliaHCTeste',
  'https://srvaplic2.famema.br/AvaliaHC',
];

export const dominioHCFamema = axios.create({
  baseURL: ambienteHCFamema[_PROD],
});

